// extracted by mini-css-extract-plugin
export default {"row":"DAGgSe","column":"ImGAl7","title":"qnZVwT","list":"xler9d","item":"MwyC66","icon":"Wb3v8s","name":"FZgnJI","description":"OZffmG"};